module.exports = __webpack_public_path__ + "img/16l006-14.39e82df7.png";